<template>
  <div class="container" v-if="goods">
    <div class="main">
      <div class="block coupon-view">
        <div class="coupon">
          <div class="left">
            <img class="tag" v-if="isPackage" :src="icons.packageTag" alt="" />
            <img class="image" :src="goods.skuImageKey" alt="" />
          </div>
          <div class="right">
            <div class="name">
              {{ goods.goodsName }}
            </div>
            <div class="date" v-if="isCoupon">
              {{ goods.couponBeginTime }} - {{ goods.couponEndTime }}
            </div>
          </div>
        </div>
        <div class="packages" v-if="isPackage">
          <div class="packages-title">申请退款的优惠券：</div>
          <div class="item" v-for="(item, index) of coupons" :key="item.id">
            <div class="left">
              <img class="image" :src="item.indexImageKey" alt="" />
            </div>
            <div class="right">
              <div class="name">{{ item.name }}</div>
              <div class="date">
                {{ item.couponBeginTime }} - {{ item.couponEndTime }}
              </div>
              <div class="view">
                <div class="desc">面额</div>
                <div class="price" v-price="item.couponValue"></div>
                <div class="desc">（满{{ item.minimumAmount }}元可用）</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block form-view">
        <div class="reason border-bottom">
          <div class="title required">退款原因</div>
          <div class="right" @click="$refs['reason-popup'].show()">
            {{ form.reason ? form.reason.name : '请选择' }}
            <img class="arrow" :src="icons.arrow" alt="" />
          </div>
        </div>
        <div class="cash border-bottom">
          <div class="view">
            <div class="title">退款金额</div>
            <div class="price" v-price="goods.goodsActualPrice"></div>
          </div>
          <div class="desc">
            最多可退{{ goods.goodsActualPrice }}元，已使用的优惠券不支持退款。
          </div>
        </div>
        <div class="explain border-bottom">
          <div class="title required">退款说明</div>
          <textarea
            class="textarea"
            v-model="form.remark"
            placeholder="请输入售后说明"
          />
        </div>
        <div class="upload">
          <div class="title">上传凭证</div>
          <div class="view">
            <div class="image-box" v-for="(item, index) of form.images">
              <img
                class="close"
                :src="icons.close"
                alt=""
                @click="onRemoveImageClick(index)"
              />
              <img class="image" :src="item.url" :key="index" alt="" />
            </div>
            <img
              class="image"
              :src="icons.upload"
              alt=""
              @click="onUploadClick"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer">
        <div class="btn" @click="onSubmit">提交申请</div>
      </div>
    </div>
    <reason-popup ref="reason-popup" @confirm="onReasonConfirm" />
  </div>
</template>

<script>
import utils from '@/utils/common';
import ReasonPopup from './reason-popup';
export default {
  components: { ReasonPopup },
  data() {
    const { subOrderId, itemId, couponTag, ids, type } = this.$route.query;
    return {
      subOrderId,
      itemId: Number(itemId),
      type: Number(type),
      couponTag: Number(couponTag),
      ids: ids && ids.split(',').map(Number),
      icons: {
        arrow:
          'https://img.chinabeego.com/uploadfile/2022/11/9/16680028896525920999187305104.png',
        upload:
          'https://img.chinabeego.com/uploadfile/2022/11/9/16680035301995921639733686251.png',
        close:
          'https://img.chinabeego.com/uploadfile/2022/11/16/16685817580169087007730856578.png',
        packageTag:
          'https://img.chinabeego.com/uploadfile/2022/11/5/16676282129595546322493632427.png'
      },
      goods: null,
      coupons: [],
      form: {
        reason: null,
        remark: '',
        images: []
      }
    };
  },
  computed: {
    viewStyle() {
      return {
        height: document.documentElement.clientHeight + 'px'
      };
    },
    isPackage() {
      return this.type === 2;
    },
    isCoupon() {
      return this.type === 1;
    }
  },
  created() {
    window['setVoucherImgKeys'] = (image) => {
      try {
        this.form.images.push(JSON.parse(image));
      } catch (error) {
        console.error(error);
      }
    };
    this.getData();
    this.isPackage && this.getCouponList();
  },
  methods: {
    onUploadClick() {
      if (this.form.images.length >= 5) {
        return this.$toast('最多上传5张图片');
      }
      utils.upLoadImg();
    },
    onReasonConfirm(reason) {
      this.form.reason = reason;
    },
    onRemoveImageClick(index) {
      this.form.images.splice(index, 1);
    },
    getData() {
      const req = this.http({
        method: 'post',
        url: 'order/appOrder/user/subOrderDetail',
        parmes: {
          subOrderId: this.subOrderId
        }
      });
      req.then((data) => {
        if (data.code === 200 && (data = data.data)) {
          const format = (v) => (v ? v.replace(/-/g, '.') : '');
          const order = data.appSubOrderDetailVoList[0] || {};
          const list = order.appSubOrderItemDetailVoList || [];
          const goods = list.find((i) => {
            const id = i.id || i.couponPackageId;
            return id === this.itemId;
          });
          if (this.isCoupon) {
            goods.couponBeginTime = format(goods.couponBeginTime);
            goods.couponEndTime = format(goods.couponEndTime);
          }
          this.goods = goods;
        }
      });
      req.finally(() => {
        this.$loading.hide();
      });
    },
    /**
     * 获取券包下的优惠券
     */
    getCouponList() {
      const req = this.http({
        method: 'post',
        url: 'order/app/findCouponListBySubOrderId',
        parmes: {
          subOrderId: this.subOrderId,
          couponTag: this.couponTag
        }
      });
      req.then((data) => {
        if (data.code === 200 && (data = data.data)) {
          const { ids } = this;
          const format = (v) => (v ? v.replace(/-/g, '.') : '');
          if (ids) {
            data = data.filter((i) => ids.includes(i.orderItemId));
          }
          data.forEach((item) => {
            item.couponBeginTime = format(item.couponBeginTime);
            item.couponEndTime = format(item.couponEndTime);
          });
          this.coupons = data;
        }
      });
    },
    getForm() {
      const { goods } = this;
      const f = this.form;
      const form = {
        type: 'COUPON_ITEM_REFUND',
        count: 1,
        subOrderId: this.subOrderId,
        remark: f.remark,
        reason: f.reason.id,
        refundAmount: goods.goodsActualPrice,
        voucherImgKeys: f.images.map((img) => img.key).join(',')
      };
      if (this.isCoupon) {
        // 单个优惠券
        form.orderItemId = this.itemId;
      } else if (this.ids) {
        // 券包部分退款
        form.orderItemIdList = this.ids;
      } else {
        // 整个券包全部退款
        form.couponTag = this.couponTag;
      }
      return form;
    },
    onSubmit() {
      const { form } = this;
      if (!form.reason) {
        return this.$toast('请选择退款原因');
      }
      if (!form.remark) {
        return this.$toast('请填写说明');
      }
      const parmes = this.getForm();
      this.$loading.show();
      let url;
      if (this.isCoupon) {
        // 单个优惠券
        url = 'order/app/newafter/apply';
      } else if (this.ids) {
        // 券包部分退款
        url = 'order/app/newafter/couponPackageItemsReturn';
      } else {
        // 整个券包全部退款
        url = 'order/app/newafter/couponPackageReturn';
      }
      const req = this.http({
        method: 'post',
        url,
        parmes
      });
      req.then((data) => {
        if (data.code === 200) {
          this.$toast('申请成功');
          utils.jumpToNewPage({
            url: `${location.origin}/h5user/couponRefundDetail?id=${data.data}`,
            noTitle: '0',
            finishPage: 1
          });
        } else {
          this.$dialog.confirm({
            message: data.data.message,
            showCancelButton: false,
            confirmButtonText: '我知道了'
          });
        }
      });
      req.finally(() => {
        this.$loading.hide();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #f2f2f2;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 24px;
  color: #3b3a38;
}
.main {
  box-sizing: border-box;
  padding: 24px;
}
.price /deep/ {
  color: #ed3939;
  i {
    font-size: 24px;
  }
  span {
    font-size: 32px;
  }
}
.border-bottom {
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    box-sizing: border-box;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 199.8%;
    height: 199.7%;
    transform: scale(0.5, 0.5);
    border-bottom: 1px solid #e1e1e1;
    z-index: 2;
  }
}
.block {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
}
.coupon-view {
  padding: 0 24px;
}
.coupon {
  display: flex;
  padding: 24px 0;
  .left {
    position: relative;
  }
  .tag {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 90px;
    height: 36px;
  }
  .image {
    display: block;
    width: 160px;
    height: 160px;
  }
  .right {
    flex: 1;
    padding-left: 20px;
  }
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
  }
  .date {
    font-size: 20px;
    color: #999999;
    margin-top: 10px;
  }
  .price {
    color: #3b3a38;
  }
}
.packages {
  padding-bottom: 24px;
  &-title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    padding: 24px 0;
  }
  .item {
    flex: 1;
    display: flex;
    position: relative;
    height: 168px;
    overflow: hidden;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    &::after {
      content: '';
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 1px;
      bottom: 0;
      z-index: 1;
      background-image: url('https://img.chinabeego.com/uploadfile/2022/11/5/16676361598275553118480578453.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .left {
    flex-shrink: 0;
    width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left .image {
    display: block;
    width: 120px;
    height: 120px;
  }
  .right {
    flex: 1;
    padding-left: 24px;
    padding: 20px 24px 0 24px;
    overflow: hidden;
    position: relative;
  }
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  }
  .date {
    font-size: 19px;
    color: #b4b4b4;
    margin-top: 12px;
    white-space: nowrap;
  }
  .view {
    display: flex;
    align-items: flex-end;
    margin-top: 12px;
    position: absolute;
    left: 24px;
    right: 0;
    bottom: 16px;
    z-index: 1;
  }
  .price /deep/ {
    margin-left: 8px;
    color: #e15554;
    i {
      font-size: 28px;
    }
    span {
      font-size: 48px;
    }
  }
  .desc {
    color: #b4b4b4;
    font-size: 22px;
  }
}
.form-view {
  padding: 0 24px;
  .title {
    display: inline-flex;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 28px;
  }
  .required {
    position: relative;
    &::after {
      content: '*';
      color: #e15554;
      position: relative;
      position: absolute;
      top: 0;
      right: -16px;
      pointer-events: none;
    }
  }
  .reason {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    height: 96px;
    .right {
      position: relative;
      font-size: 28px;
      display: flex;
      align-items: center;
    }
    .arrow {
      display: block;
      width: 48px;
      height: 48px;
      margin-right: -12px;
    }
  }
  .cash {
    padding: 36px 0;
    .view {
      display: flex;
      justify-content: space-between;
    }
    .desc {
      color: #b4b4b4;
      font-size: 24px;
      margin-top: 16px;
    }
  }
  .explain {
    padding: 36px 0;
    .textarea {
      margin-top: 16px;
      width: 100%;
      display: block;
      resize: none;
      border: 0;
      outline: 0;
      height: 240px;
      background-color: #f6f6f6;
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;
    }
  }
  .upload {
    padding: 36px 0;
    .view {
      display: flex;
      flex-wrap: wrap;
      margin-top: 36px;
    }
    .image-box {
      position: relative;
      margin-right: 24px;
      margin-bottom: 24px;
    }
    .close {
      position: absolute;
      top: -16px;
      right: -16px;
      z-index: 1;
      width: 48px;
      height: 48px;
    }
    .image {
      display: block;
      width: 138px;
      height: 138px;
      object-fit: contain;
    }
  }
}
.footer-box {
  height: 100px;
}
.footer {
  height: 100px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  .btn {
    flex: 1;
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 28px;
    font-weight: 500;
    height: 80px;
    border-radius: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffd102;
  }
}
</style>
